import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const attachmentReplacementCandidateApi = createApi({
  reducerPath: 'attachmentReplacementCandidateApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/v1/attachment_replacement_candidates'
  }),
  endpoints: (builder) => ({
    createAttachmentReplacementCandidate: builder.mutation({
      query: (data) => ({
        method: 'POST',
        body: { attachment_replacement_candidate: data }
      })
    })
  })
})

const { useCreateAttachmentReplacementCandidateMutation } =
  attachmentReplacementCandidateApi

export {
  attachmentReplacementCandidateApi,
  useCreateAttachmentReplacementCandidateMutation
}
